module.exports = __webpack_public_path__ + "img/2023-01-09c_1.c6f5776d.jpg";